export default "__VITE_ASSET__1768f5ce__"